/**
 *  @class
 *  @function Pagination
 */

if (!customElements.get('pagination')) {
  class Pagination extends HTMLElement {
    constructor() {
      super();
      const id = this.dataset.section;
      this.button = this.querySelector('.load-more');
      this.grid = document.querySelector('[data-id=' + id + ']');
      this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
      // Next page to fetch (page 1 is already on the document).
      this.i = 2;
    }
    connectedCallback() {
      if (this.classList.contains('pagination-type--loadmore')) {
        this.loadMore();
      }
      if (this.classList.contains('pagination-type--infinite')) {
        this.infinite();
      }

    }
    addUrlParam(search, key, value) {
      var newParam = key + '=' + value,
        params = '?' + newParam;

      // If the "search" string exists, then build params from it
      if (search) {
        // Try to replace an existance instance
        params = search.replace(new RegExp('([?&])' + key + '[^&]*'), '$1' + newParam);

        // If nothing was replaced, then add the new param to the end
        if (params === search) {
          params += '&' + newParam;
        }
      }

      return params;
    }
    loadMore() {
      let base = this;
      this.button.addEventListener('click', function () {
        base.loadProducts();
        this.blur();
        return false;
      });
    }
    infinite() {
      let base = this;
      base.observer = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting && entries[0].intersectionRatio >= 0.99) {
          base.loadProducts();
        }
      }, {
        threshold: [0, 0.99, 1]
      });
      base.observer.observe(base);
    }
    maybeLoadNextPage() {
      if (!this.observer || !this.classList.contains('pagination-type--infinite')) {
        return;
      }
      const rect = this.getBoundingClientRect();
      const inView = rect.top < window.innerHeight && rect.bottom > 0 &&
        rect.top >= 0 && rect.bottom <= window.innerHeight;
      if (inView || (rect.top < window.innerHeight && rect.bottom > 0 && rect.height <= window.innerHeight)) {
        this.loadProducts();
      }
    }
    loadProducts() {
      let base = this;
      if (base.getAttribute('loading')) {
        return;
      }
      const page = base.i;
      const url = document.location.pathname + base.addUrlParam(document.location.search, 'page', page);
      base.setAttribute('loading', true);
      fetch(url)
        .then(response => response.text())
        .then((responseText) => {
          base.i = page + 1;
          base.renderProducts(responseText, url);

          dispatchCustomEvent('pagination:page-changed', {
            url: url
          });
        })
        .catch(() => {
          base.removeAttribute('loading');
        });
    }
    loadStampedBadges() {
      if (typeof window.StampedFn !== 'undefined' && typeof window.StampedFn.loadBadges === 'function') {
        window.StampedFn.loadBadges();
      }
    }
    refreshLazyImages(products) {
      if (!window.lazySizes || !lazySizes.loader) {
        return;
      }
      const unveil = () => {
        Array.prototype.forEach.call(products, (product) => {
          product.querySelectorAll('img.lazyload').forEach((img) => {
            lazySizes.loader.unveil(img);
          });
        });
        if (typeof lazySizes.loader.checkElems === 'function') {
          lazySizes.loader.checkElems();
        }
      };
      // Wait for layout so data-sizes="auto" sees real dimensions.
      requestAnimationFrame(() => {
        requestAnimationFrame(unveil);
      });
    }
    finishLoading(products) {
      this.removeAttribute('loading');
      this.refreshLazyImages(products);
      this.loadStampedBadges();
      // Fast scroll: sentinel may still be fully visible, but IntersectionObserver
      // will not re-fire until it leaves and re-enters — queue the next page now.
      this.maybeLoadNextPage();
    }
    renderProducts(html, url) {
      let base = this,
        grid_to_replace = new DOMParser().parseFromString(html, 'text/html').getElementById('product-grid');

      if (!grid_to_replace) {
        if (base.observer) {
          base.observer.unobserve(base);
        }
        base.removeAttribute('loading');
        if (base.button) {
          base.button.classList.add('visually-hidden');
        }
        dispatchCustomEvent('pagination:exhausted');
        return;
      }
      let products = grid_to_replace.querySelectorAll('.column');

      for (var i = 0; i < products.length; i++) {
        this.grid.appendChild(products[i]);
      }

      // Unveil as soon as nodes are in the DOM — do not wait for entrance animation.
      base.refreshLazyImages(products);

      if (this.animations_enabled) {
        gsap.set(products, {
          opacity: 0,
          y: 30
        });
        gsap.to(products, {
          duration: 0.5,
          y: 0,
          opacity: 1,
          stagger: 0.05,
          onStart: function () {
            // Unlock during animation so a fast scroll can fetch the next page.
            base.removeAttribute('loading');
            base.maybeLoadNextPage();
          },
          onComplete: function () {
            base.refreshLazyImages(products);
            base.loadStampedBadges();
          }
        });
      } else {
        base.finishLoading(products);
      }
    }
  }
  customElements.define('pagination-theme', Pagination);
}
